import React from 'react';
import { formatAffairAmount } from '../../affairs/affairFormatters';
import PartnerRelatedItemsTable from './PartnerRelatedItemsTable';

const columns = [
  { key: 'code', label: 'Code', render: (row) => row.code || '—' },
  { key: 'name', label: 'Nom', render: (row) => row.name || '—' },
  { key: 'status', label: 'Statut projet', render: (row) => row.status || '—' },
  { key: 'sold', label: 'Montant vendu', render: (row) => formatAffairAmount(row.soldAmount || row.sold_amount) },
  { key: 'progress', label: 'Avancement', render: (row) => `${Number(row.progressPercent ?? row.progress_percent ?? 0)} %` },
];

export default function PartnerProjectsPanel({ rows, onNavigate }) {
  return <section className="partner-section"><PartnerRelatedItemsTable rows={rows} columns={columns} onOpen={(row) => onNavigate(`/projets/${row.id}`)} emptyMessage="Aucun projet lié." /></section>;
}
